import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthUserFacadeService } from '../services/auth-user-facade.service';
import { NavigationWebService } from '../services/navigation.service';

export const NotAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthUserFacadeService);
  const navService = inject(NavigationWebService);
  const router = inject(Router);
  const user = authService.getAuthProfile();

  if (user && Object.keys(user || {}).length !== 0) {
    return router.createUrlTree(navService.getBaseSegments());
  }

  return true;
};
